import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '升学地图',
      requireAuth: true,
      content: {
        keywords: '升学、上学、入托、入园、幼升小、小升初、初升高、幼儿园面试、小学考试、中考、高考、等级证书考试、英语、语文、数学、启蒙',
        description: '升学、上学、入托、入园、幼升小、小升初、初升高、幼儿园面试、小学考试、中考、高考、等级证书考试、英语、语文、数学、启蒙'
      }
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import( /* webpackChunkName: "about" */ '../views/About.vue'),
    meta: {
      title: '升学地图',
      requireAuth: true,
      content: {
        keywords: '升学、上学、入托、入园、幼升小、小升初、初升高、幼儿园面试、小学考试、中考、高考、等级证书考试、英语、语文、数学、启蒙',
        description: '升学、上学、入托、入园、幼升小、小升初、初升高、幼儿园面试、小学考试、中考、高考、等级证书考试、英语、语文、数学、启蒙'
      }
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, form, next) => {
  console.log(to.meta.content)
  if (to.meta.content) {
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next()
  // if (to.meta.content) {
  //   console.log(to.meta.content)
  //   let head = document.getElementsByTagName('head');
  //   let meta = document.createElement('meta');
  //   meta.content = to.meta.content;
  //   head[0].appendChild(meta)
  // }
  // /* 路由发生变化修改页面title */
  // if (to.meta.title) {
  //   document.title = to.meta.title;
  // }
  // next()
})

export default router